import { combineReducers } from 'redux';
import setReducer from './reducer';

const rootReducer = combineReducers({
  setReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
